var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('the-header'),_c('router-view'),_c('footer',{staticClass:"mt-10 block"},[_c('the-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }